import { extend } from 'flarum/common/extend';
import app from 'flarum/forum/app';
import HeaderSecondary from 'flarum/forum/components/HeaderSecondary';
import UnansweredTicketsDropdown from './Components/Dropdowns/UnansweredTicketsDropdown';

export default function () {
  extend(HeaderSecondary.prototype, 'items', function (items) {
    if (
      app.forum.attribute('supportTicketsEnabled') &&
      app.forum.attribute('supportTicketNotificationsInHeader') &&
      app.forum.attribute('canViewTickets')
    ) {
      items.add('openTickets', <UnansweredTicketsDropdown state={app.supportOpenTicketsState} />, 20);
    }
  });
}
